var map = {
	"./albert einstein.jpg": 13595,
	"./android.jpg": 9195,
	"./apple logo.jpg": 48473,
	"./chat gpt.jpg": 4901,
	"./fb.jpg": 20560,
	"./ms office.jpg": 10022,
	"./uc browser 1.jpg": 10901,
	"./whats app.jpg": 72590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83278;